import { render, staticRenderFns } from "./MoreAppointments.vue?vue&type=template&id=7837bac8"
import script from "./MoreAppointments.vue?vue&type=script&lang=js"
export * from "./MoreAppointments.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports